import { accessRole } from "../../../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"
import Select from "react-select"

import TableActiveComponent from './Components/TablePrimaryComponent'
// import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

const IndexView = (props) => {

    // const { type } = props
    const jenisLaporanOption = [
        {value:'struktural',label:'Struktural'},
        {value:'8',label:'Rekap Ketidakhadiran Perunit'},
        {value:'2',label:'Rekap Akumulasi Kehadiran Perunit'},
        {value:'3',label:'Rekap Izin Perunit'},
        {value:'6',label:'Rekap Izin Perunit(Include sabtu/minggu & tanggal merah)'},
        {value:'7',label:'Rekap Izin Surat Tugas'},
    ]
    const [type, setSelectedType] = useState("Teknis")    
    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();
    const [isLoadingSelectType, setIsLoadingSelectType] = useState(true);

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        {/* <PegawaiSideBar active={`diklat&type=${type}`} /> */}
                        
                        <Card className="">
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to={`?diklat&type=${type}&create`}>
                                            <Button color="primary">Tambah Diklat</Button>
                                        </Link>
                                    : null
                                }
                                </div>
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Jenis Laporan
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={jenisLaporanOption.filter(option =>
                                                option.value === type.value)}
                                            onChange={(s) => setSelectedType(s)}
                                            required="required"
                                            options={jenisLaporanOption}
                                            isLoading={isLoadingSelectType}
                                            classNamePrefix="select2-unit"
                                            defaultValue={"1"}
                                        />
                                    </Col>
                                </Row> */}
                                <CardTitle>Daftar Diklat {type}</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Diklat {type}
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent type={type} ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView
